import { render, staticRenderFns } from "./DOList.vue?vue&type=template&id=31109360&scoped=true&"
import script from "./DOList.vue?vue&type=script&lang=js&"
export * from "./DOList.vue?vue&type=script&lang=js&"
import style0 from "./DOList.vue?vue&type=style&index=0&id=31109360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31109360",
  null
  
)

export default component.exports